<template>
   <div>
      <div class="spinner-container" v-if="loading">
         <BeatLoader color="#1389EF" />
      </div>
      <div v-else>
         <!-- abonnement en grace period  -->
         <div
            v-if="user.abonnement && user.abonnement.stripe_status == 'active' && user.abonnement.ends_at"
         >
            <div class="sous-titre">Votre abonnement</div>
            <div class="container-mobile">
               Votre abonnement a été annulé mais vous bénéficiez encore des services premium jusqu'au
               <strong>{{ date_fin }}.</strong>
               <div style="margin-top:25px">
                  <b-button
                     type="is-primary"
                     outlined
                     @click="reactiver()"
                     :loading="loading_form"
                  >Réactiver l'abonnement</b-button>
               </div>
            </div>
         </div>

         <!-- ABONNEMENT TOTALEMENT ACTIF  -->
         <div
            v-if="user.abonnement && user.abonnement.stripe_status == 'active' && !user.abonnement.ends_at"
         >
            <div class="sous-titre">Votre abonnement</div>
            <div class="container-mobile">
               Vous êtes bien abonné à l'offre
               <strong>premium.</strong>
               <br />Votre prochain prélèvement de
               <strong>{{ abonnement_infos.plan.amount / 100 }} €</strong> aura lieu le
               <strong>{{ date_fin }}</strong>.
            </div>
            <div class="container-mobile" style="margin-top:20px;">
               <b-button
                  type="is-danger"
                  outlined
                  @click="desabonner()"
                  :loading="loading_form"
               >Se désabonner</b-button>
            </div>
         </div>
      </div>

      <!-- AUCUN ABONNEMENT (inclus abo annulé et à expiration) -->
      <div
         v-if="user.abonnement == null || (user.abonnement && user.abonnement.stripe_status == 'canceled')"
         v-show="show_formulaire"
      >
         <div class="sous-titre">S'abonner à premium</div>

         <div class="container-mobile">
            <form id="payment-form">
               <b-field label="Nom sur la carte">
                  <b-input required id="card-holder-name" v-model="cardHolderName"></b-input>
               </b-field>
               <b-field label="Adresse de facturation">
                  <b-input required v-model="adresse"></b-input>
               </b-field>
               <b-field label="Code Postal">
                  <b-input required v-model="code_postal"></b-input>
               </b-field>
               <b-field label="Ville">
                  <b-input required v-model="ville"></b-input>
               </b-field>

               <!-- Card -->
               <b-field label="Carte">
                  <div id="card-element"></div>
               </b-field>

               <a @click="showCodePromo = !showCodePromo">Un code promo ?</a>
               <b-field
                  label="Code promo"
                  v-show="showCodePromo"
                  label-position="on-border"
                  style="margin-top:30px;"
                  :type="type"
               >
                  <b-input v-model="code_promo"></b-input>
               </b-field>

               <div class="container-mobile">
                  <b-button
                     style="margin-bottom:25px; margin-top:20px"
                     native-type="submit"
                     type="is-primary"
                     id="card-button"
                     :loading="loading_form"
                  >Payer {{ prix }} € /an</b-button>
               </div>
            </form>
         </div>
      </div>
   </div>
</template>

<script>
   import axios from "axios";
   import moment from "moment/src/moment";
   import { BeatLoader } from "@saeris/vue-spinners";

   export default {
      components: { BeatLoader },
      data() {
         return {
            show_formulaire: true,
            intent: null,
            loading: true,
            loading_form: false,
            cardHolderName: "",
            code_promo: "",
            adresse: "",
            code_postal: "",
            ville: "",
            showCodePromo: false,
            codes_promo: ["LANCEMENT", "SIMAPI"],
            abonnement_infos: null,
            date_fin: null
         };
      },

      async mounted() {
         this.$store.commit("setTitre", "Gestion d'abonnement");

         if (
            this.user.abonnement == null ||
            this.user.abonnement.stripe_status == "canceled"
         ) {
            this.loading = true;
            let res = await axios.get("abonnement/intent");
            this.intent = res.data.intent;
            let stripe_key = res.data.stripe_pk;
            this.loading = false;

            const stripe = window.Stripe(stripe_key);
            const elements = stripe.elements();
            const cardElement = elements.create("card");

            cardElement.mount("#card-element");

            const cardButton = document.getElementById("card-button");

            cardButton.addEventListener("click", async e => {
               e.preventDefault();
               this.loading_form = true;
               const { setupIntent, error } = await stripe.handleCardSetup(
                  this.intent.client_secret,
                  cardElement,
                  {
                     payment_method_data: {
                        billing_details: { name: this.cardHolderName }
                     }
                  }
               );

               if (error) {
                  this.$buefy.toast.open({
                     message: error.message,
                     type: "is-danger"
                  });
               } else {
                  axios
                     .post("/abonnement/premium", {
                        stripeToken: setupIntent.payment_method,
                        code_promo: this.type,
                        adresse: this.adresse,
                        code_postal: this.code_postal,
                        ville: this.ville
                     })
                     .then(async () => {
                        this.loading_form = false;
                        this.show_formulaire = false;
                        await this.getAbonnementInfos();
                        await this.$store.dispatch("getUser");
                        this.show_formulaire = true;
                        this.$buefy.toast.open({
                           message: "Vous êtes désormais abonné !",
                           type: "is-success"
                        });
                     });
               }
            });
         }

         // si abonné
         if (
            this.user.abonnement &&
            this.user.abonnement.stripe_status == "active"
         ) {
            this.getAbonnementInfos();
         }
      },
      computed: {
         user() {
            return this.$store.state.user;
         },
         type() {
            if (this.codes_promo.includes(this.code_promo.toUpperCase())) {
               return "is-success";
            }
            return "";
         },
         prix() {
            if (this.type == "is-success") {
               return 36 * 0.8;
            }
            return 36;
         }
      },
      methods: {
         async reactiver() {
            this.loading_form = true;
            let res = await axios.post("abonnement/reactiver");
            if (res.data.erreur) {
               this.$buefy.toast.open({
                  message: res.data.erreur,
                  type: "is-danger"
               });
               this.loading_form = false;
            } else {
               this.loading_form = false;
               this.$buefy.toast.open({
                  message: "Vous êtes réabonné.",
                  type: "is-success"
               });
               this.loading = true;
               await this.$store.dispatch("getUser");
               this.loading = false;
            }
         },
         async getAbonnementInfos() {
            this.loading = true;
            let res = await axios.get("/abonnement/infos");
            this.abonnement_infos = res.data;
            this.date_fin = moment
               .unix(res.data.current_period_end)
               .format("DD/MM/YYYY");
            this.loading = false;
         },
         async desabonner() {
            this.$buefy.dialog.confirm({
               message: "Êtes-vous sûr ? Vous serez à nouveau limité à 10 ruches.",
               cancelText: "Annuler",
               confirmText: "Se désabonner",
               type: "is-danger",
               onConfirm: () => {
                  this.loading_form = true;
                  axios.post("/abonnement/annuler").then(() => {
                     this.loading = true;
                     this.$store.dispatch("getUser").then(() => {
                        this.loading = false;
                     });
                     this.loading_form = false;
                     this.$buefy.toast.open({
                        message: "Vous êtes désormais désabonné.",
                        type: "is-success"
                     });
                  });
               }
            });
         }
      }
   };
</script>
